import React from 'react';
import ReactSVG from 'react-svg';

import iconFile from 'appSrc/v5/assets/icons/wildlife/x.svg';

const CloseIcon = ( props ) => {
    const className = `icon-wrapper ${ props.className }`.trim();

    return (
        <ReactSVG src={ iconFile }
        wrapper='div'
        { ...props }
        className={ className } />
    );
};
CloseIcon.defaultProps = {
    className: '',
};

export default CloseIcon;
